// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessDefaultGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * AddUserGrid component
 */

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import { Table } from 'share/components/controls/DataGrid/Izenda.Table';
import { Column } from 'share/components/controls/DataGrid/Izenda.Table';
import Paginator from 'share/components/controls/DataGrid/helpers/Izenda.Paginator';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import AccessConstants from 'logic/data/Izenda.AccessConstants';
import AccessStore from 'logic/Izenda.PermissionAccessStore';
import { getOr, join, map, filter, isEmpty, values, take } from 'lodash/fp';
@connect()
export default class AccessDefaultGrid extends Component {
  constructor(props) {
    super(props);
    const { loadUsers, userModeType } = props;
    this.store = new AccessStore(loadUsers, userModeType);
  }

  componentDidMount() {
    const { loader, data } = this.props;
    this.store.updateAccessOrigin(data);
    loader.startLoading();
    this.store.loadAllAccess(data).finally(loader.endLoading.bind(loader));
  }

  /**
   *
   * @param {Object} data     cell data
   * @param {number} key      cell key
   * @param {number} rowIndex cell index
   * @param {number} column   cell column
   */
  renderTextCell(data: any, key: number, rowIndex: number, column: number): any {
    const text = data[key] || '';
    return <OverflowText tooltip={text} text={text} />;
  }

  /**
   *
   * @param {Object} data     cell data
   * @param {number} key      cell key
   * @param {number} rowIndex cell index
   * @param {number} column   cell column
   */
  renderAccessorCell(data: any, key: number, rowIndex: number, column: number) {
    const text = data[key] || [];

    const value = join(', ', map(item => item, filter(item => !isEmpty(item), text)));

    return (
      <div title={value}>{map(item => <OverflowText text={item} tooltip={item} key={item} />, take(3, text))}</div>
    );
  }

  /**
   * Render table component
   */
  renderTable() {
    const { store, store: { model, model: { pageInfo } } } = this;

    /**
     * Render columns component
     */
    const renderColumns = () => {
      return map(item => {
        switch (item.key) {
          case 'accessorNames':
            return <Column {...item} cell={this.renderAccessorCell} />;
          default:
            return <Column {...item} cell={this.renderTextCell} />;
        }
      }, values(AccessConstants.ACCESS_DEFAULT_GRID));
    };

    return (
      <Table
        dataSource={model.visibleAccessList}
        onSortChange={store.onSortChange.bind(store)}
        draggableTable={false}
        sortInfo={pageInfo.colSortDirs}
      >
        {renderColumns()}
      </Table>
    );
  }

  onPageSizeChange = (value: number): void => {
    this.store.onPageSizeChange(value);
  };

  goToPage = (value: number): void => {
    this.store.goToPage(value);
  }

  /**
   * Render component
   */
  render() {
    const { store, store: { model, model: { pageInfo } } } = this;

    const currentPageSize = getOr(0, 'length', model.visibleAccessList);
    return (
      <GridLayout>
        <GridLayout.Row>
          <GridLayout.Col cols="12">{this.renderTable()}</GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols="12">
            <Paginator
              onChange={this.goToPage}
              onDropdownChange={this.onPageSizeChange}
              pageInfo={pageInfo}
              currentPageSize={currentPageSize}
            />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.AccessDefaultGrid.js